import { InteractionType, PublicClientApplication, LogLevel, BrowserCacheLocation } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { IAppConfig } from '../app-config/app-config';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export function MSALInstanceFactory(appConfig: IAppConfig): PublicClientApplication {
  const b2cConfig = appConfig.azure.b2c;

  return new PublicClientApplication({
      auth: {
          clientId: b2cConfig.clientId,
          authority: `${b2cConfig.instance}/${b2cConfig.domain}/${b2cConfig.signUpSignInPolicyId}`,
          knownAuthorities: [b2cConfig.instance],
          redirectUri: '/',
      },
      cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: isIE,
      },
      system: {
          loggerOptions: {
              loggerCallback: (logLevel, message, containsPii) => {
                  console.log(message)
              },
              logLevel: LogLevel.Warning,
              piiLoggingEnabled: false
          }
      }
  });
}

export function MSALInterceptorConfigFactory(appConfig: IAppConfig): MsalInterceptorConfiguration {
  const b2cConfig = appConfig.azure.b2c;
  const apiConfig = appConfig.api;
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(apiConfig.url, b2cConfig.scopes);

  return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: []
        }
    };
}
